import { Grid } from '@mui/material'
import React, { useContext } from 'react'
import { confirmationPopoverInterface } from '../slack/integratedChannels'
import ConfirmationPopover from '../../../../utility/confirmationPopover';
import { ChatbotContext, ChatbotContextPayload } from '../../../../../context/chatbotContext';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';
import { zohoIntegrationList } from '../../../../../models/axiosModel';
import FacebookInformationCard from '../../../../utility/facebookInformationCard';
import GlobalButton from '../../../../utility/globalButton/button';
import IconsColor from '../../../../utility/iconsColor';
import integrationStyles from "../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";

interface ShowAllZohoAccountProps {
    confirmationPopover: confirmationPopoverInterface, 
    setConfirmationPopover: React.Dispatch<React.SetStateAction<confirmationPopoverInterface>>, 
    handleDeployZohoAccount: () => void, 
    addZohoIntegration: (zoho_integration_id: string, account_name: string, zoho_integration_organization_id: number, event?: React.MouseEvent<HTMLButtonElement>) => void, 
    handleZohoIntegration: () => void,
} 

const ShowAllZohoAccount: React.FC<ShowAllZohoAccountProps> = (props) => {

    const {confirmationPopover, setConfirmationPopover, handleDeployZohoAccount, addZohoIntegration, handleZohoIntegration} = props;
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload; 
    const {zohoIntegrations} = useContext(IntegrationContext) as IntegrationContextPayload

    return (
        <>
            <Grid container className={integrationStyles.showAllZohoAccountGridContainer}>
                <Grid item>
                    <Grid container className={`${globalStyles.gapLess}`}>
                            <ConfirmationPopover
                                open={confirmationPopover.flagOpen}
                                anchorEl={confirmationPopover.anchorEl}
                                handleClose={() => setConfirmationPopover(({ ...confirmationPopover, anchorEl: null, flagOpen: false, channel_name: "" }))}
                                onConfirmation={() => { handleDeployZohoAccount() }}
                                descriptionText={<p>Are you sure you want to integrate <span className={`${globalStyles.primaryFontWeight}`}>{chatBotDetails?.chatbot_name}</span> with <span className={`${globalStyles.primaryFontWeight}`}>{confirmationPopover.channel_name}'s Zoho Account</span> ?</p>}
                            />
                            <Grid item>
                                <Grid container className={`${globalStyles.gapLess}`}>
                                    {zohoIntegrations &&  zohoIntegrations.length > 0 && 
                                        zohoIntegrations.map((zohoAcc: zohoIntegrationList, index: number) => {
                                            return (
                                                <Grid item key={index}>
                                                    <FacebookInformationCard 
                                                        integrationType='Zoho'
                                                        key={index}
                                                        flagShowLinkedChatbot
                                                        flagDelete={false}
                                                        disabled={zohoAcc.zoho_integration_organization_data?.[0]?.zoho_integration_organization_chatbot_data?.length > 0 ? true : false}
                                                        title={`Zoho Account ${index + 1}`} 
                                                        currentlySelected={zohoAcc.zoho_integration_organization_data?.[0]?.zoho_integration_organization_chatbot_data?.length > 0 ? true : false}
                                                        removeChatbotIntegration={() => {}}
                                                        addChatbotIntegration={(zoho_integration_id, event) => {
                                                            addZohoIntegration(String(zohoAcc.zoho_integration_id), zohoAcc.zoho_user_name, zohoAcc.zoho_integration_organization_data?.[0]?.zoho_integration_organization_id, event);
                                                        }}
                                                        flagIntegration={true}
                                                        details={{
                                                            page_id: String(zohoAcc.zoho_user_id),
                                                            integrated_channel_id: "",
                                                            page_name: zohoAcc.zoho_user_name,
                                                            page_category: zohoAcc.zoho_user_email, 
                                                            linked_chatbots: zohoAcc.zoho_integration_organization_data?.[0]?.zoho_integration_organization_chatbot_data
                                                        }}
                                                    />
                                                </Grid>
                                            );
                                        })
                                    }
                                </Grid>
                            </Grid>
                    </Grid>
                </Grid> 
                <Grid item>
                    <GlobalButton buttonText={"Zoho Account"} onClick={() => handleZohoIntegration()} className={'blackShadowedButton'}
                        startIcon={<IconsColor fillColor="#A5A5A5" iconName="plus" width="19px" height="19px" />}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default ShowAllZohoAccount
